export default "__VITE_ASSET__tTQ5IEZi__"